import { STATES } from '../../constants/states';
import { ITEM_DEFINITION_CODES as codes } from '../../constants/item-definitions';
import { selectors } from '../../state';

export const TITLE = 'Start with one of these important steps';
export const DASHBOARD_STATE = STATES.DASHBOARD;
export const DASHBOARD_LABEL = 'Or, see my customized dashboard';

export const STEP_NAME_TO_CODES = {
  'Home Security': {
    code: codes.HOME_SECURITY,
    state: STATES.STEP_HOME_SECURITY,
  },
  MoveIQ: {
    code: codes.MOVEIQ,
    state: STATES.STEP_MOVEIQ,
  },
  Promotions: {
    code: codes.PROMOTION,
    state: STATES.STEP_PROMOTIONS,
  },
  'TV/Internet': {
    code: codes.HOME_SERVICE_APP,
    state: STATES.STEP_HOME_SERVICES_APP,
  },
  'Update Your Accounts': {
    code: codes.UPDATE_ACCOUNT,
    state: STATES.STEP_UPDATE_ACCOUNTS,
  },
  'Forward Mail': {
    code: codes.FORWARD_MAIL,
    state: STATES.STEP_FORWARD_MAIL_NEW,
  },
  'DIY Move': {
    code: codes.DIY_MOVE,
    state: STATES.STEP_DIY_MOVE,
  },
  Insurance: {
    code: codes.INSURANCE,
    state: STATES.STEP_INSURANCE,
  },
  'Home Services': {
    code: codes.HOME_SERVICE,
    state: STATES.STEP_HOME_SERVICES,
  },
};

export const overrides = {
  [codes.HOME_SECURITY]: {
    exclusion: state => {
      const toAddress = selectors.current.move(state).toAddress(state);
      return toAddress && toAddress.ownership === 'own';
    },
  },
  [codes.HOME_SERVICE_APP]: {
    bonus: state => {
      const { recommender, clientName } = getMetadata(state);
      if (!recommender || !clientName) {
        return '';
      }
      return `${clientName}s of ${recommender} qualify for QuickSetup&#8482;`;
    },
  },
  [codes.PROMOTION]: {
    bullets: (state, definition) => {
      const { recommender, clientName } = getMetadata(state);
      if (!recommender || !clientName) {
        return definition.bullets;
      }
      return [
        `Special deals for ${clientName}s of ${recommender}`,
        'Save on items and services for your move and new home',
      ];
    },
  },
};

const getMetadata = state => {
  const {
    channelClientName,
    companyDisplayName,
    companyName,
    hasDivision,
    divisionName,
  } = selectors.current.siteConfig();

  const recommender = hasDivision(state)
    ? divisionName(state)
    : companyDisplayName(state) || companyName(state);
  const clientName = channelClientName(state);

  return {
    clientName,
    recommender,
  };
};

export const allowedItems = Object.keys(STEP_NAME_TO_CODES).map(
  key => STEP_NAME_TO_CODES[key].code
);
